"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const ArrowBackIos_1 = __importDefault(require("@material-ui/icons/ArrowBackIos"));
const lp_components_1 = require("lp-components");
const react_router_dom_1 = require("react-router-dom");
function BackButton() {
    const history = (0, react_router_dom_1.useHistory)();
    const handleBack = () => {
        history.goBack();
    };
    return ((0, jsx_runtime_1.jsxs)(lp_components_1.Button, { className: "button-primary-outline d-flex-center back-button", onClick: handleBack, children: [(0, jsx_runtime_1.jsx)(ArrowBackIos_1.default, { height: '18px' }), "Back to Search"] }));
}
exports.default = BackButton;
